import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import SectionLayout from "reusables/layouts/SectionLayout";

const steps = [
  {
    step: "01",
    icon: "chat",
    title: "Tell Us What You Need",
    description:
      "Contact us with your requirements — product types, quantities, and delivery frequency. We'll match you with the right products for your facility.",
  },
  {
    step: "02",
    icon: "request_quote",
    title: "Receive a Tailored Quote",
    description:
      "We provide a clear, itemised quote with no hidden charges — priced for business volumes and structured around your usage patterns.",
  },
  {
    step: "03",
    icon: "event_repeat",
    title: "Agree Your Supply Schedule",
    description:
      "Choose a one-off order or a recurring delivery schedule. We'll set up your account and confirm your preferred delivery frequency.",
  },
  {
    step: "04",
    icon: "local_shipping",
    title: "We Deliver to Your Door",
    description:
      "Products are delivered directly to your facility on the agreed schedule — reliably and on time, so you never run out of essentials.",
  },
  {
    step: "05",
    icon: "tune",
    title: "Review & Adjust",
    description:
      "We check in regularly to review your usage. If your needs change, we adjust your order — scaling up, down, or swapping products as required.",
  },
  {
    step: "06",
    icon: "support_agent",
    title: "Ongoing Account Support",
    description:
      "Your dedicated account contact is always available to handle queries, process new orders, and ensure your supply chain runs without interruption.",
  },
];

function HowItWorks() {
  return (
    <SectionLayout
      mt={20}
      title="How It Works"
      description="Getting your facility supplied by Spechs is straightforward — from first contact to regular delivery."
      contents={
        <Container>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {steps.map(({ step, icon, title, description }) => (
              <Grid item xs={12} sm={6} lg={4} key={step}>
                <MKBox
                  sx={{
                    background: "white",
                    borderRadius: 3,
                    border: "1px solid #e9ecef",
                    overflow: "hidden",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "box-shadow 0.25s ease",
                    "&:hover": { boxShadow: "0 12px 40px rgba(0,0,0,0.1)" },
                  }}
                >
                  {/* Icon block */}
                  <MKBox
                    sx={{
                      background: "#fff8ee",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pt: 3,
                      pb: 2.5,
                      px: 4,
                    }}
                  >
                    <MKBox
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        background: "white",
                        boxShadow: "0 8px 24px rgba(255,159,28,0.18)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon sx={{ fontSize: "28px !important", color: "#ff9f1c" }}>{icon}</Icon>
                    </MKBox>
                  </MKBox>

                  {/* Text */}
                  <MKBox p={3} sx={{ flex: 1 }}>
                    <MKTypography
                      variant="caption"
                      sx={{
                        color: "#adb5bd",
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                        display: "block",
                        mb: 0.5,
                      }}
                    >
                      STEP {step}
                    </MKTypography>
                    <MKTypography variant="h6" fontWeight="bold" sx={{ color: "#32373c", mb: 1 }}>
                      {title}
                    </MKTypography>
                    <MKTypography variant="body2" sx={{ color: "#6c757d", lineHeight: 1.7 }}>
                      {description}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Container>
      }
    />
  );
}

export default HowItWorks;
